import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"text-align":"right"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, { class: "mx-0 mb-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_spacer),
        (!_ctx.newRowActive && _ctx.editIndex === null)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "mt-8 mt-md-0",
              onClick: _ctx.startNewRow
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" Agregar tipo de cliente ")
              ])),
              _: 1,
              __: [4]
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      headers: _ctx.headers,
      items: _ctx.clientTypes,
      "item-value": "id",
      class: "elevation-0",
      "hide-default-footer": ""
    }, {
      header: _withCtx(({ props }) => [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (header) => {
            return (_openBlock(), _createElementBlock("th", {
              key: header.value
            }, _toDisplayString(header.text), 1))
          }), 128))
        ])
      ]),
      [`body.prepend`]: _withCtx(() => [
        (_ctx.newRowActive)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
              _createElementVNode("td", null, [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.newRow.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newRow.name) = $event)),
                  label: "Nombre",
                  dense: "",
                  "hide-details": "",
                  variant: "solo"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.newRow.tag,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newRow.tag) = $event)),
                  label: "Tag",
                  dense: "",
                  "hide-details": "",
                  variant: "solo"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  size: "small",
                  onClick: _ctx.cancelNewRow
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" Cancelar ")
                  ])),
                  _: 1,
                  __: [5]
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  size: "small",
                  onClick: _ctx.saveNewRow
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode(" Guardar ")
                  ])),
                  _: 1,
                  __: [6]
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      item: _withCtx(({ item, index }) => [
        _createElementVNode("tr", null, [
          (_ctx.editIndex === index)
            ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.editItem.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editItem.name) = $event)),
                  label: "Nombre",
                  dense: "",
                  "hide-details": "",
                  variant: "solo"
                }, null, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(item.name), 1)),
          (_ctx.editIndex === index)
            ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.editItem.tag,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editItem.tag) = $event)),
                  label: "Tag",
                  dense: "",
                  "hide-details": "",
                  variant: "solo"
                }, null, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(item.tag), 1)),
          _createElementVNode("td", _hoisted_7, [
            (_ctx.editIndex !== index)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  icon: "",
                  variant: "text",
                  size: "x-small",
                  onClick: ($event: any) => (_ctx.startEditRow(index, item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("mdi-pencil")
                      ])),
                      _: 1,
                      __: [7]
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    size: "small",
                    onClick: _ctx.cancelEdit
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Cancelar ")
                    ])),
                    _: 1,
                    __: [8]
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    size: "small",
                    class: "mr-2",
                    onClick: ($event: any) => (_ctx.saveEditRow(item))
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode(" Guardar ")
                    ])),
                    _: 2,
                    __: [9]
                  }, 1032, ["onClick"])
                ], 64)),
            (_ctx.editIndex !== index)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 2,
                  icon: "",
                  variant: "text",
                  size: "x-small",
                  onClick: ($event: any) => (_ctx.deleteRow(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("mdi-delete")
                      ])),
                      _: 1,
                      __: [10]
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 2
    }, 1032, ["headers", "items"])
  ]))
}